import { ArbeitszeitReportFilters, ArbeitszeitReportResponse } from '@myapp/contract'
import { useQuery } from '@tanstack/react-query'
import { arbeitszeitReportApi } from '../arbeitszeitReportApi'
import { arbeitszeitReportKeys } from '../keys'

export function useArbeitszeitReportQuery(filters: ArbeitszeitReportFilters) {
  return useQuery<ArbeitszeitReportResponse>({
    queryKey: arbeitszeitReportKeys.list(filters),
    queryFn: () => arbeitszeitReportApi.search(filters).then((r) => r.data),
    placeholderData: (prev) => prev,
  })
}
